import React from 'react'
import { Text } from '@mantine/core'
import { ScratchCard } from 'next-scratchcard'

interface ScratchCardViewProps {
  onComplete: () => Promise<void>
  isLoading?: boolean
}

const ScratchCardView: React.FC<ScratchCardViewProps> = ({ onComplete, isLoading = false }) => {
  return (
    <div
      style={{
        margin: '0 auto',
        width: '90%',
        height: 225,
        border: '6px solid #FF5A5A',
        borderRadius: 12,
        position: 'relative',
        overflow: 'hidden',
        touchAction: 'none',
        background: 'linear-gradient(135deg, #FF6B6B 0%, #FF5A5A 50%, #E74C3C 100%)',
        boxShadow: `
          0 8px 32px rgba(255, 90, 90, 0.3),
          0 4px 16px rgba(255, 90, 90, 0.2),
          inset 0 2px 4px rgba(255, 255, 255, 0.2)
        `,
        transform: 'perspective(1000px) rotateX(2deg)',
        opacity: isLoading ? 0.8 : 1,
        pointerEvents: isLoading ? 'none' : 'auto',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: -20,
          right: -20,
          width: 80,
          height: 80,
          background: 'radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 70%)',
          borderRadius: '50%',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: -30,
          left: -30,
          width: 100,
          height: 100,
          background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.03) 70%)',
          borderRadius: '50%',
        }}
      />

      <ScratchCard
        finishPercent={30}
        brushSize={20}
        onComplete={onComplete}
        width={window.innerWidth > 480 ? 400 : window.innerWidth - 70}
        height={211}
        image={'/scratchCardCover.png'}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #FFF9E6 0%, #FFF5CC 50%, #FFEDAA 100%)',
            padding: 12,
            touchAction: 'none',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `
                radial-gradient(circle at 20% 20%, rgba(255, 90, 90, 0.1) 2px, transparent 2px),
                radial-gradient(circle at 80% 80%, rgba(255, 90, 90, 0.1) 2px, transparent 2px),
                radial-gradient(circle at 40% 70%, rgba(255, 90, 90, 0.1) 1px, transparent 1px)
              `,
              backgroundSize: '30px 30px, 40px 40px, 20px 20px',
            }}
          />

          <Text
            size="md"
            fw={600}
            style={{
              color: '#FF5A5A',
              fontSize: 22,
              textShadow: '0 2px 4px rgba(255, 90, 90, 0.3)',
              position: 'relative',
              zIndex: 1,
            }}
          >
            {isLoading ? '抽奖中...' : '刮开查看奖品'}
          </Text>
        </div>
      </ScratchCard>
    </div>
  )
}

export default ScratchCardView
